import { render, staticRenderFns } from "./AppDashboardPage.vue?vue&type=template&id=04fc96a4&scoped=true"
import script from "./AppDashboardPage.vue?vue&type=script&lang=js"
export * from "./AppDashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc96a4",
  null
  
)

export default component.exports